import React, { useState } from "react";
import "./Tooltip.scss";

const Tooltip = (props: any) => {
  let timeout: any;
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 400);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <div
      className="Tooltip-Wrapper"
      onMouseEnter={() => {
        showTip();
      }}
      onMouseLeave={() => {
        hideTip();
      }}
      onClick={() => {
        if (props.hideOnClick === true) {
          hideTip();
        }
      }}
      style={{ ...props.wrapperStyle }}
    >
      {props.children}
      {active && (
        <div
          style={props.style}
          className={`Tooltip-Tip ${props.direction || "top"} ${
            props.className
          }`}
        >
          {props.content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
